module.exports = __webpack_public_path__ + "img/gj.af23466d.png";